import { PREFIX } from '@app/constants';

type TArg = string | number;

export function generateKey(...args: TArg[]): string {
  return `${PREFIX}${args.join('-')}`;
}
